module.exports = __webpack_public_path__ + "static/media/bsre.ed44f4ce.png";